module.exports = __webpack_public_path__ + "img/iso.16075ce5.png";